import { DEFAULT_CACHE_STALE_TIME_MS } from "@frontend-shared/constants/app";
import type {
  IAppConfigResponse,
  TWireAppConfig,
} from "@frontend-shared/types/app-config";
import { fromWireFormat } from "@frontend-shared/utils/from-wire-format";
import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/services";

const APP_CONFIG_QUERY_KEY = "app-config";

const getAppConfig = async (): Promise<IAppConfigResponse> => {
  const response = await apiClient.get<TWireAppConfig>("/app-config");
  return fromWireFormat(response.data);
};

export const useAppConfig = () => {
  return useQuery({
    queryKey: [APP_CONFIG_QUERY_KEY],
    queryFn: getAppConfig,
    staleTime: DEFAULT_CACHE_STALE_TIME_MS,
  });
};
